import { STARTPAGETITLES } from "InterfacesTypes/enums";
import { useSelector } from "react-redux";
import { selectTitleTexts } from "state/selectors/Selectors";

const NotificationBanner = () => {
    const titleTexts = useSelector(selectTitleTexts);
    const updateText = titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.UPDATE_NOTIFICATION);

    return (
        <>
            {updateText?.Description &&
                <div className="ml-[40px] border-2 rounded-md p-2 mb-3 mr-[40px] bg-blue-200 border-blue-700!">
                    <p className="m-0">
                        {updateText.Description}
                    </p>
                </div>
            }
        </>
    )
}

export default NotificationBanner;